import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { BasculeMobileComponent } from './bascule-mobile.component';
import { SharedModule } from '@shared/shared.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
@NgModule({
    declarations: [BasculeMobileComponent],
    imports: [
        CommonModule,
        BrowserModule,
        FormsModule,
        SharedModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatAutocompleteModule,
    ],
    exports: [BasculeMobileComponent, CommonModule, BrowserModule, FormsModule],
})
export class BasculeMobileModule {}
